import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { TopHeader } from '@transferz/fe-component-library/src/components/topHeader/TopHeader';
import { Language } from '../../components/language/Language';
import './header.scss';

export const Header: React.FC = () => {
  const flags = useFlags();
  const isLoginPage = window.location.pathname === '/';

  return (
    flags?.showNewDesign
      ? <TopHeader
        language={<Language />}
        helpdeskUrl="https://booking.taxi2airport.com/help"
        // logoUrl={isLoginPage ? '' : bookingDetails?.partner?.styleConfiguration?.logoUrl || '/images/T2A-logo.png'}
        logoUrl={'/images/T2A-logo.png'}
        // borderColor={bookingDetails?.partner?.styleConfiguration?.primaryColor || '#F6C82F'}
        borderColor={'#F6C82F'}
      />
      : <header>
        <img alt="logo" className="logo" src="/images/T2A-logo.png" />
      </header>
  );
};
